import styled from 'styled-components'

export const StyledChefPeopleLogo = styled.div`
  position: absolute;
  top: ${({ theme }) => theme.rem(16)};
  left: ${({ theme }) => theme.rem(16)};
  ${({ theme }) => theme.size(72)};
  z-index: 1  ;
`
